<div class="hot-toast-animated-icon" [style.color]="iconTheme()?.primary">
    <ng-content></ng-content>
</div>
